import React, { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import health51 from '../../assets/health51.png';
import gate51 from '../../assets/gate51.png';



export default function HeaderBlock() {

    let location = useLocation();

    useEffect(() => {
        console.log('location: ', location)
    }, [location]);


    useLayoutEffect(() => {
        document.documentElement.scrollTo({
            top: 0,
            left: 0,
            behavior: "instant",
        });
    }, [location.pathname]);


    return (
        <div style={{
            background: '#000',
            color: '#fff',
            padding: '14px 16px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '20px',
            flexWrap: 'wrap',
            fontSize: '0.9rem'
        }}>
            <span style={{ textTransform: 'uppercase', letterSpacing: '1px' }}>Scopri anche:</span>
            <a href="https://health51.it/" target="_blank" rel="noopener noreferrer" style={{ display: 'inline-flex', alignItems: 'center' }}>
                <img src={health51} alt="Health51" style={{ height: '36px', width: 'auto', display: 'block' }} />
            </a>
            <a href="https://gate51.it/" target="_blank" rel="noopener noreferrer" style={{ display: 'inline-flex', alignItems: 'center' }}>
                <img src={gate51} alt="Gate51" style={{ height: '36px', width: 'auto', display: 'block' }} />
            </a>
        </div>
    );
};
